<template>
  <Modal
    v-show="
      (activeStep <= 2 && !useProfessionalGradLoanOptionsModal) ||
      (useProfessionalGradLoanOptionsModal && activeStep === 1) ||
      !hasRepaymentBasedRates
    "
    class="loan-configuration-modal"
    id="pel-configuration"
    :closeBtn="true"
    @close="closeModal"
  >
    <PelBorrowAmount
      v-if="activeStep === 1"
      :isCurrent="activeStep === 1"
      @close="closeModal"
      @complete="complete"
    />
    <PelLoanOptions
      v-if="activeStep === 2 && !hasRepaymentBasedRates"
      :isCurrent="activeStep === 2"
      :loading="loading"
      @previous="goBack"
      @complete="complete"
    />
  </Modal>
  <PgLoanOptionsModal
    ref="PgLoanOptionsModalRef"
    v-if="activeStep === 2 && hasRepaymentBasedRates"
    @configurationComplete="complete"
    @close="$emit('close')"
    :closeBtn="true"
  />
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/shared/Modal.vue";
import PelLoanOptions from "@/components/pel-loan-configuration/PelLoanOptions.vue";
import PelBorrowAmount from "@/components/pel-loan-configuration/PelBorrowAmount.vue";
import PgLoanOptionsModal from "@/components/professional-grad/PgLoanOptionsModal.vue";
import useApplicationData from "@/composables/useApplicationData";

const store = useStore();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "configurationComplete"): void;
}>();

const activeStep = ref<number>(1);

const loading = ref<boolean>(true);

const { useProfessionalGradLoanOptionsModal, hasRepaymentBasedRates, isValidProfessionalGradFlow } =
  useApplicationData();

function closeModal() {
  emit("close");
  store.dispatch("applicationInfoModule/closeModal", "PelLoanConfigurationModal");
}

function goBack() {
  if (activeStep.value === 2) {
    activeStep.value -= 1;
  }
}

function complete() {
  if (activeStep.value === 1) {
    borrowAmountComplete();
  } else {
    next();
    emit("configurationComplete");
  }
}

function borrowAmountComplete() {
  next();
}

function next() {
  if (activeStep.value < 2) {
    activeStep.value++;
  }
}

onMounted(async () => {
  loading.value = false;
});
</script>

<style>
.loan-configuration-modal#pel-configuration .modal-container {
  width: 95vw;
  max-width: none;
}

.loan-configuration-modal .step-btns {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;
}

.loan-configuration-modal .step-btns button:not(:first-child) {
  margin-left: 10px;
}

.loan-configuration-modal .step-btns button {
  min-width: 110px;
  height: 34px;
  font-size: 0.875rem;
  font-weight: 600;
}

.loan-configuration-modal .step-content .content {
  width: 100%;
}

.loan-configuration-modal .modal-body {
  overflow-x: hidden;
}

@media (max-width: 992px) {
  .loan-configuration-modal .step-btns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .loan-configuration-modal .modal-body {
    overflow-x: auto;
  }
}
</style>
